/* ATTRM patch map v1. MapLibre + OpenFreeMap; data from the patch-map section. */
(function () {
  'use strict';

  var CATS = {
    'Summit': { k: 's', label: 'Summits', one: 'Summit' },
    'National Trail': { k: 'nt', label: 'National Trails', one: 'National Trail' },
    "Scotland's Great Trail": { k: 'sgt', label: "Scotland's Great Trails", one: "Scotland's Great Trail" },
    'Other UK Trail': { k: 'other', label: 'Other UK Trails', one: 'UK Trail' }
  };
  var ORDER = ['s', 'nt', 'sgt', 'other'];
  var BY_KEY = {};
  Object.keys(CATS).forEach(function (name) { BY_KEY[CATS[name].k] = CATS[name]; });
  var HOME = [[-10.6, 49.85], [1.85, 58.75]];
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var NEAREST = 8;

  var libPromise = null;
  function loadLib(js, css) {
    if (window.maplibregl) return Promise.resolve(window.maplibregl);
    if (libPromise) return libPromise;
    libPromise = new Promise(function (resolve, reject) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = css;
      document.head.appendChild(link);
      var s = document.createElement('script');
      s.src = js;
      s.async = true;
      s.onload = function () { resolve(window.maplibregl); };
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return libPromise;
  }

  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (a) {
      if (a === 'text') n.textContent = attrs[a];
      else if (a === 'class') n.className = attrs[a];
      else if (a === 'style') n.setAttribute('style', attrs[a]);
      else if (a.indexOf('on') === 0) n.addEventListener(a.slice(2), attrs[a]);
      else if (attrs[a] !== null && attrs[a] !== undefined && attrs[a] !== false) n.setAttribute(a, attrs[a] === true ? '' : attrs[a]);
    });
    (kids || []).forEach(function (k) { if (k) n.appendChild(typeof k === 'string' ? document.createTextNode(k) : k); });
    return n;
  }

  function miles(a, b) {
    var R = 3958.8, toR = Math.PI / 180;
    var dLat = (b.lat - a.lat) * toR, dLng = (b.lng - a.lng) * toR;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a.lat * toR) * Math.cos(b.lat * toR) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.asin(Math.sqrt(h));
  }

  function norm(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[’']/g, '');
  }

  function shapeImage(kind, fill, px) {
    var r = 2, w = px * r, h = px * r;
    var c = document.createElement('canvas');
    c.width = w; c.height = h;
    var g = c.getContext('2d');
    g.lineJoin = 'round';
    g.lineWidth = 2 * r;
    g.strokeStyle = '#ffffff';
    g.fillStyle = fill;
    g.beginPath();
    if (kind === 'tri') {
      g.moveTo(w / 2, 2.5 * r);
      g.lineTo(w - 2.5 * r, h - 3.5 * r);
      g.lineTo(2.5 * r, h - 3.5 * r);
      g.closePath();
    } else {
      g.arc(w / 2, h / 2, w / 2 - 3 * r, 0, Math.PI * 2);
    }
    g.fill();
    g.stroke();
    return { width: w, height: h, data: g.getImageData(0, 0, w, h).data };
  }

  function PatchMap(root) {
    this.root = root;
    this.ds = root.dataset;
    var raw = root.querySelector('[data-pmap-data]');
    var data = { items: [], sets: [], challenges: [] };
    try { data = JSON.parse(raw.textContent); } catch (e) { console.error('Patch map data', e); }
    this.colors = { s: this.ds.cS, nt: this.ds.cNt, sgt: this.ds.cSgt, other: this.ds.cOther, soldout: this.ds.cSoldout };
    this.posterZoom = parseFloat(this.ds.posterZoom) || 7.5;
    this.state = { cat: 'all', q: '', sel: -1, near: false, me: null };
    this.prepare(data);
    this.cacheDom();
    this.bindUi();
    this.renderChips();
    this.renderLegend();
    this.renderList();
    this.lazyInit();
  }

  PatchMap.prototype.prepare = function (data) {
    var setsByHandle = {};
    (data.sets || []).forEach(function (s) {
      (s.m || []).forEach(function (h) { (setsByHandle[h] = setsByHandle[h] || []).push(s); });
    });
    var challenges = data.challenges || [];
    this.items = (data.items || []).map(function (it, i) {
      var cat = CATS[it.type];
      if (!cat) return null;
      return {
        i: i,
        id: it.id,
        h: it.h,
        name: (it.t || '').replace(/\s+Patch$/i, ''),
        title: it.t,
        c: cat.k,
        lat: parseFloat(it.lat),
        lng: parseFloat(it.lng),
        url: it.url,
        img: it.img,
        alt: it.alt,
        price: it.price,
        avail: !!it.avail,
        v: it.v,
        route: it.route || null,
        hasLine: false,
        sets: setsByHandle[it.h] || [],
        challenges: (it.ch || []).map(function (k) { return challenges[k]; }).filter(Boolean),
        key: norm(it.t)
      };
    }).filter(function (it) { return it && isFinite(it.lat) && isFinite(it.lng); });
    this.items.forEach(function (it, idx) { it.i = idx; });
    this.cats = ORDER.filter(function (k) { return this.items.some(function (it) { return it.c === k; }); }, this);
  };

  PatchMap.prototype.cacheDom = function () {
    var q = this.root.querySelector.bind(this.root);
    this.dom = {
      chips: q('[data-pmap-chips]'),
      search: q('[data-pmap-q]'),
      nearBtns: Array.prototype.slice.call(this.root.querySelectorAll('[data-pmap-near]')),
      nearLabel: q('[data-pmap-near-label]'),
      mapbox: q('.pmap__mapbox'),
      map: q('[data-pmap-map]'),
      loading: q('[data-pmap-loading]'),
      legend: q('[data-pmap-legend]'),
      reset: q('[data-pmap-reset]'),
      toast: q('[data-pmap-toast]'),
      panel: q('[data-pmap-panel]'),
      grab: q('[data-pmap-grab]'),
      card: q('[data-pmap-card]'),
      listwrap: q('[data-pmap-listwrap]'),
      listTitle: q('[data-pmap-listtitle]'),
      listNote: q('[data-pmap-listnote]'),
      list: q('[data-pmap-list]'),
      empty: q('[data-pmap-empty]'),
      intro: q('[data-pmap-intro]')
    };
  };

  PatchMap.prototype.isMobile = function () {
    return window.matchMedia('(max-width: 749px)').matches;
  };

  PatchMap.prototype.bindUi = function () {
    var self = this, d = this.dom;
    var t = null;
    d.search.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        self.state.q = d.search.value.trim();
        if (self.state.q && self.state.near) self.setNear(false, true);
        self.state.sel = -1;
        self.update();
      }, 120);
    });
    d.search.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var first = self.listed()[0];
        if (first) self.select(first.it.i, { fly: true, focus: true });
      }
    });
    d.nearBtns.forEach(function (b) {
      // Always (re)locate and re-centre on the visitor; "Show all" on the map turns Near me off.
      b.addEventListener('click', function () { if (!self._locating) self.setNear(true); });
    });
    d.reset.addEventListener('click', function () { self.home(); });
    // Label shown on the map while Near me is fading the other pins, with a one-tap way out.
    d.nearbar = el('div', { class: 'pmap__nearbar', role: 'status', hidden: true }, [
      el('span', { text: 'Showing your ' + NEAREST + ' nearest patches' }),
      el('button', { type: 'button', class: 'pmap__nearoff', text: 'Show all', onclick: function () { self.setNear(false); } })
    ]);
    d.mapbox.appendChild(d.nearbar);
    d.panel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.state.sel > -1) { e.stopPropagation(); self.clearSel(true); }
    });
    this.bindSwipe();
  };

  PatchMap.prototype.bindSwipe = function () {
    var self = this, panel = this.dom.panel, startY = null, dy = 0;
    panel.addEventListener('touchstart', function (e) {
      if (!self.isMobile() || panel.scrollTop > 0) { startY = null; return; }
      startY = e.touches[0].clientY; dy = 0;
    }, { passive: true });
    panel.addEventListener('touchmove', function (e) {
      if (startY === null) return;
      dy = Math.max(0, e.touches[0].clientY - startY);
      panel.style.transform = dy ? 'translateY(' + dy + 'px)' : '';
    }, { passive: true });
    panel.addEventListener('touchend', function () {
      if (startY === null) return;
      panel.style.transform = '';
      if (dy > 70) self.dismissSheet();
      startY = null;
    });
  };

  PatchMap.prototype.dismissSheet = function () {
    if (this.state.sel > -1) { this.clearSel(false); }
    else {
      if (this.state.near) this.setNear(false, true);
      if (this.state.q) { this.state.q = ''; this.dom.search.value = ''; }
      this.update();
    }
  };

  /* ---------- Lists, chips, card ---------- */

  PatchMap.prototype.visible = function (it) {
    return this.state.cat === 'all' || it.c === this.state.cat;
  };

  PatchMap.prototype.matches = function (it) {
    var q = norm(this.state.q);
    return !q || it.key.indexOf(q) !== -1;
  };

  PatchMap.prototype.listed = function () {
    var self = this, s = this.state;
    if (s.near && s.me) {
      return this.items.filter(this.visible, this)
        .map(function (it) { return { it: it, d: miles(s.me, it) }; })
        .sort(function (a, b) { return a.d - b.d; })
        .slice(0, NEAREST);
    }
    return this.items.filter(function (it) { return self.visible(it) && self.matches(it); })
      .sort(function (a, b) { return a.name.localeCompare(b.name); })
      .map(function (it) { return { it: it }; });
  };

  PatchMap.prototype.renderChips = function () {
    var self = this, d = this.dom;
    if (this.cats.length < 2) { d.chips.hidden = true; return; }
    d.chips.hidden = false;
    d.chips.textContent = '';
    ['all'].concat(this.cats).forEach(function (k) {
      var n = k === 'all' ? self.items.length : self.items.filter(function (it) { return it.c === k; }).length;
      var on = self.state.cat === k;
      var btn = el('button', {
        type: 'button', class: 'pmap__chip' + (on ? ' is-on' : ''), 'aria-pressed': on ? 'true' : 'false',
        onclick: function () { self.state.cat = k; self.state.sel = -1; self.renderChips(); self.update(); }
      }, [
        k === 'all' ? null : el('span', { class: 'pmap__dot pmap__dot--' + (k === 's' ? 'tri' : 'line'), style: 'background:' + self.colors[k], 'aria-hidden': 'true' }),
        el('span', { text: k === 'all' ? 'All' : BY_KEY[k].label }),
        el('span', { class: 'pmap__chipn', text: String(n) })
      ]);
      d.chips.appendChild(btn);
    });
  };

  PatchMap.prototype.renderLegend = function () {
    var d = this.dom, self = this;
    d.legend.textContent = '';
    var rows = [];
    if (this.cats.indexOf('s') > -1) rows.push(['tri', this.colors.s, 'Summit patch']);
    this.cats.filter(function (k) { return k !== 's'; }).forEach(function (k) {
      rows.push(['line', self.colors[k], BY_KEY[k].label + ' (pin marks the start)']);
    });
    if (this.items.some(function (it) { return !it.avail; })) rows.push(['tri', this.colors.soldout, 'Back soon']);
    rows.forEach(function (r) {
      d.legend.appendChild(el('div', { class: 'pmap__legrow' }, [
        el('span', { class: 'pmap__dot pmap__dot--' + r[0], style: 'background:' + r[1], 'aria-hidden': 'true' }),
        el('span', { text: r[2] })
      ]));
    });
    d.legend.hidden = rows.length < 2;
  };

  PatchMap.prototype.renderList = function () {
    var self = this, d = this.dom, s = this.state;
    var rows = this.listed();
    d.list.textContent = '';
    rows.forEach(function (r) {
      var it = r.it;
      var right = r.d !== undefined ? '≈ ' + Math.max(1, Math.round(r.d)) + ' mi' : (it.avail ? it.price : 'Back soon');
      var col = it.avail ? self.colors[it.c] : self.colors.soldout;
      d.list.appendChild(el('li', null, [
        el('button', {
          type: 'button', class: 'pmap__item', 'data-i': it.i,
          onclick: function () { self.select(it.i, { fly: true, focus: true }); }
        }, [
          el('span', { class: 'pmap__dot pmap__dot--' + (it.c === 's' ? 'tri' : 'line'), style: 'background:' + col, 'aria-hidden': 'true' }),
          el('span', { class: 'pmap__itemtext' }, [
            el('span', { class: 'pmap__itemname', text: it.name }),
            el('span', { class: 'pmap__itemsub', text: BY_KEY[it.c].one })
          ]),
          el('span', { class: 'pmap__itemright', text: right })
        ])
      ]));
    });
    var title;
    if (s.near && s.me) title = 'Nearest to you';
    else if (s.q) title = rows.length + (rows.length === 1 ? ' match' : ' matches');
    else if (s.cat === 'all') title = 'All ' + rows.length + ' patches';
    else title = BY_KEY[s.cat].label + ' (' + rows.length + ')';
    d.listTitle.textContent = title;
    d.listNote.textContent = s.near && s.me ? 'As the crow flies' : 'A to Z';
    d.empty.hidden = !(s.q && rows.length === 0);
  };

  PatchMap.prototype.renderCard = function () {
    var self = this, d = this.dom;
    var it = this.items[this.state.sel];
    d.card.textContent = '';
    if (!it) { d.card.hidden = true; d.listwrap.hidden = false; return; }
    var col = it.avail ? this.colors[it.c] : this.colors.soldout;
    var media = el('div', { class: 'pmap__media' + (it.avail ? '' : ' is-soldout') }, [
      it.img ? el('img', { src: it.img, alt: it.alt || it.title, width: '240', height: '240', loading: 'lazy' }) : null,
      it.avail ? null : el('span', { class: 'pmap__soon', text: 'Back soon' })
    ]);
    var actions = el('div', { class: 'pmap__actions' }, [
      el('a', { class: 'button button--secondary', href: it.url, text: 'View patch' }),
      it.avail ? el('button', {
        type: 'button', class: 'button button--primary', text: 'Add to basket', 'aria-haspopup': 'dialog',
        onclick: function (e) { self.addToBasket(it, e.currentTarget); }
      }) : null
    ]);
    var links = [];
    if (it.sets.length) links.push(this.linkGroup('Complete the set', it.sets));
    if (it.challenges.length) links.push(this.linkGroup('Complete the challenge', it.challenges));
    var note = (it.c !== 's' && !it.hasLine) ? el('p', { class: 'pmap__note', text: 'Route line coming soon. The pin shows where the trail starts.' }) : null;
    var title = el('h2', { class: 'pmap__cardtitle', tabindex: '-1', text: it.name });
    d.card.appendChild(el('div', { class: 'pmap__cardtop' }, [
      el('span', { class: 'pmap__tag', style: 'background:' + col, text: BY_KEY[it.c].one }),
      el('button', {
        type: 'button', class: 'pmap__close', 'aria-label': 'Close patch card',
        onclick: function () { self.clearSel(true); }
      }, [this.closeIcon()])
    ]));
    d.card.appendChild(media);
    d.card.appendChild(el('div', { class: 'pmap__cardhead' }, [
      title,
      el('p', { class: 'pmap__price' }, [el('strong', { text: it.price }), it.avail ? null : ' · Sold out, back soon'])
    ]));
    d.card.appendChild(actions);
    if (note) d.card.appendChild(note);
    links.forEach(function (l) { d.card.appendChild(l); });
    d.card.hidden = false;
    d.listwrap.hidden = true;
    this.cardTitle = title;
  };

  PatchMap.prototype.linkGroup = function (label, list) {
    return el('div', { class: 'pmap__links' }, [
      el('p', { class: 'pmap__linkslabel', text: label }),
      el('ul', null, list.map(function (p) {
        return el('li', null, [
          el('a', { class: 'pmap__link', href: p.url }, [
            el('span', { text: p.t }),
            el('span', { class: 'pmap__linkprice', text: (p.avail === false ? 'Back soon' : p.price) + ' →' })
          ])
        ]);
      }))
    ]);
  };

  PatchMap.prototype.closeIcon = function () {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('width', '16'); svg.setAttribute('height', '16');
    svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false');
    var p = document.createElementNS(ns, 'path');
    p.setAttribute('d', 'M6 6l12 12M18 6L6 18'); p.setAttribute('stroke', 'currentColor');
    p.setAttribute('stroke-width', '2.2'); p.setAttribute('stroke-linecap', 'round'); p.setAttribute('fill', 'none');
    svg.appendChild(p);
    return svg;
  };

  PatchMap.prototype.update = function () {
    var s = this.state;
    this.renderList();
    this.renderCard();
    var sheetOpen = s.sel > -1 || (s.near && s.me) || !!s.q;
    this.root.classList.toggle('pmap--sheet', sheetOpen);
    var nearOn = !!(s.near && s.me);
    this.dom.nearbar.hidden = !nearOn;
    this.root.classList.toggle('pmap--near', nearOn);
    this.syncMap();
  };

  // Map-assisted tracking: the first time someone opens a patch card, note it on the cart.
  // Shopify carries cart attributes onto the order ("Additional details": Patch map = Used).
  PatchMap.prototype.markUsed = function () {
    if (this._markP) return this._markP;
    var self = this;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    this._markP = fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Patch map': 'Used' } }),
      keepalive: true
    }).then(function (r) { if (!r.ok) throw new Error('cart attribute ' + r.status); })
      .catch(function (e) { console.warn('Patch map tracking', e); self._markP = null; });
    return this._markP;
  };

  PatchMap.prototype.select = function (i, opts) {
    opts = opts || {};
    this.markUsed();
    this.lastFocus = document.activeElement;
    this.state.sel = i;
    this.update();
    var it = this.items[i];
    if (this.map && it && opts.fly) this.flyToItem(it);
    if (opts.focus && this.cardTitle) this.cardTitle.focus({ preventScroll: true });
  };

  PatchMap.prototype.clearSel = function (restoreFocus) {
    var prev = this.state.sel;
    this.state.sel = -1;
    this.update();
    if (restoreFocus) {
      var btn = this.dom.list.querySelector('[data-i="' + prev + '"]');
      if (btn && !this.isMobile()) btn.focus();
      else if (this.lastFocus && document.body.contains(this.lastFocus)) this.lastFocus.focus();
    }
  };

  PatchMap.prototype.setNear = function (on, silent) {
    var self = this;
    var label = function (txt, pressed) {
      self.dom.nearBtns.forEach(function (b) { b.setAttribute('aria-pressed', pressed ? 'true' : 'false'); b.classList.toggle('is-busy', txt === 'Finding you…'); });
      if (self.dom.nearLabel) self.dom.nearLabel.textContent = txt;
    };
    if (!on) {
      this.state.near = false;
      label('Near me', false);
      if (!silent) { this.update(); }
      return;
    }
    if (!navigator.geolocation) { this.toast('Your browser can’t share its location.'); return; }
    label('Finding you…', true);
    this._locating = true;
    navigator.geolocation.getCurrentPosition(function (pos) {
      self._locating = false;
      self.state.me = { lat: pos.coords.latitude, lng: pos.coords.longitude };
      self.state.near = true;
      self.state.sel = -1;
      self.state.q = '';
      self.dom.search.value = '';
      label('Near me', true);
      self.update();
      self.fitNearest();
    }, function () {
      self._locating = false;
      label('Near me', !!self.state.near);
      self.toast('Couldn’t get your location. Check location access for this site and try again.');
    }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 });
  };

  PatchMap.prototype.toast = function (msg, html) {
    var t = this.dom.toast;
    t.textContent = '';
    if (html) t.appendChild(html); else t.textContent = msg;
    t.hidden = false;
    clearTimeout(this._toastT);
    this._toastT = setTimeout(function () { t.hidden = true; }, 4000);
  };

  /* ---------- Basket ---------- */

  PatchMap.prototype.addToBasket = function (it, btn) {
    var self = this;
    if (!it.v || btn.getAttribute('aria-disabled') === 'true') return;
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('pmap-busy');
    var drawer = document.querySelector('cart-drawer');
    var notification = document.querySelector('cart-notification');
    var upcart = typeof window.upcartRefreshCart === 'function';
    var themeCart = !upcart ? (drawer || notification) : null;
    var body = { items: [{ id: it.v, quantity: 1 }] };
    if (themeCart && typeof themeCart.getSectionsToRender === 'function') {
      body.sections = themeCart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      if (typeof themeCart.setActiveElement === 'function') themeCart.setActiveElement(btn);
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    // Make sure the "Patch map" cart note has landed before adding, so the two cart writes don't race.
    Promise.resolve(this.markUsed()).then(function () {
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      });
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        var j = res.j;
        if (!res.ok || j.status) throw new Error(j.description || j.message || 'Sorry, that couldn’t be added.');
        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'patch-map', productVariantId: it.v, cartData: j });
          }
        } catch (e) { /* theme pubsub optional */ }
        if (upcart) {
          window.upcartRefreshCart();
          if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
          self.toast('Added ' + it.name + ' to your basket');
        } else if (themeCart && j.sections && typeof themeCart.renderContents === 'function') {
          themeCart.renderContents(j);
          self.toast('Added ' + it.name + ' to your basket');
        } else {
          var a = el('span', null, ['Added ' + it.name + ' to your basket. ', el('a', { href: (window.routes && window.routes.cart_url) || root + 'cart', text: 'View basket' })]);
          self.toast(null, a);
        }
      })
      .catch(function (err) { self.toast(err.message || 'Sorry, that couldn’t be added.'); })
      .finally(function () { btn.removeAttribute('aria-disabled'); btn.classList.remove('pmap-busy'); });
  };

  /* ---------- Map ---------- */

  PatchMap.prototype.lazyInit = function () {
    var self = this;
    var go = function () {
      if (self.started) return;
      self.started = true;
      loadLib(self.ds.libJs, self.ds.libCss).then(function (ml) { self.initMap(ml); }).catch(function (e) {
        self.mapFailed(e);
      });
    };
    if (!('IntersectionObserver' in window)) { go(); return; }
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); go(); }
    }, { rootMargin: '300px 0px' });
    io.observe(this.dom.mapbox);
  };

  // If the map can't start on a device (e.g. no WebGL), fall back to the patch list
  // and show the reason in small print so it can be reported.
  PatchMap.prototype.mapFailed = function (e) {
    console.error('Patch map', e);
    var reason = (e && (e.message || e.type)) || 'unknown error';
    var d = this.dom.loading;
    d.textContent = '';
    d.appendChild(el('span', { class: 'pmap__failmsg' }, [
      el('span', { text: 'The map couldn’t load on this device. You can still browse every patch below.' }),
      el('small', { class: 'pmap__failwhy', text: '(' + reason + ')' })
    ]));
    d.hidden = false;
    if (this.map) { try { this.map.remove(); } catch (x) { /* ignore */ } this.map = null; }
    this.root.classList.add('pmap--nomap');
  };

  PatchMap.prototype.bounds = function () {
    var w = HOME[0][0], s = HOME[0][1], e = HOME[1][0], n = HOME[1][1];
    this.items.forEach(function (it) { w = Math.min(w, it.lng); e = Math.max(e, it.lng); s = Math.min(s, it.lat); n = Math.max(n, it.lat); });
    return [[w, s], [e, n]];
  };

  PatchMap.prototype.padding = function () {
    if (this.isMobile()) {
      var sheet = this.root.classList.contains('pmap--sheet') ? Math.min(this.dom.panel.offsetHeight, this.dom.mapbox.offsetHeight * 0.55) : 0;
      return { top: 40, bottom: 40 + sheet, left: 24, right: 24 };
    }
    return { top: 40, bottom: 40, left: 40, right: 40 };
  };

  PatchMap.prototype.initMap = function (ml) {
    var self = this;
    var map = new ml.Map({
      container: this.dom.map,
      style: this.ds.style,
      bounds: this.bounds(),
      fitBoundsOptions: { padding: 20 },
      maxBounds: [[-26, 44], [16, 63.5]],
      minZoom: 3.5,
      maxZoom: 16,
      attributionControl: false,
      dragRotate: false,
      pitchWithRotate: false,
      touchPitch: false,
      cooperativeGestures: false
    });
    this.map = map;
    this.homeZoom = map.getZoom();
    map.touchZoomRotate.disableRotation();
    map.keyboard.disableRotation && map.keyboard.disableRotation();
    map.addControl(new ml.NavigationControl({ showCompass: false }), 'top-right');
    map.addControl(new ml.AttributionControl({
      compact: true,
      // OpenFreeMap / OpenMapTiles / OpenStreetMap credits come from the tile source itself
      // and show whenever its map data is on screen; only the hills credit is added here.
      customAttribution: this.ds.credit ? [this.ds.credit] : []
    }), 'bottom-right');

    map.on('style.load', function () { self.onStyle(); });
    map.on('error', function (e) {
      if (e && e.error) console.warn('Patch map', e.error.message || e.error);
      if (!self.styleReady) self.mapFailed(e && e.error ? e.error : e);
    });
    map.on('zoomend', function () { self.dom.reset.hidden = map.getZoom() < self.homeZoom + 1.2; });
    map.on('click', function (e) { self.onMapClick(e); });
    map.on('mousemove', function (e) {
      var f = self.hit(e.point);
      map.getCanvas().style.cursor = f ? 'pointer' : '';
    });
  };

  PatchMap.prototype.onStyle = function () {
    var map = this.map, self = this, Z = this.posterZoom;
    if (!map) return;
    this.styleReady = true;
    this.homeZoom = map.getZoom();
    // Restyle the base map in poster colours and hide it below the poster zoom.
    var recolour = {
      background: ['background-color', '#F4F0E6'],
      water: ['fill-color', '#C7DBE2'],
      park: ['fill-color', '#E3EAD6'],
      landcover_wood: ['fill-color', '#D9E4CF'],
      landuse_residential: ['fill-color', '#ECE6DA'],
      waterway: ['line-color', '#B5CFD9']
    };
    var poster = this.ds.poster === 'true';
    map.getStyle().layers.forEach(function (l) {
      if (recolour[l.id]) { try { map.setPaintProperty(l.id, recolour[l.id][0], recolour[l.id][1]); } catch (e) { /* layer differs */ } }
      if (!poster || l.type === 'background') return;
      try { map.setLayerZoomRange(l.id, Math.max(l.minzoom || 0, Z - 0.75), l.maxzoom === undefined ? 24 : l.maxzoom); } catch (e) { /* ignore */ }
    });

    // Optional poster-style outline when zoomed out (section setting "Poster view").
    if (poster) {
      var fade = ['interpolate', ['linear'], ['zoom'], Z - 0.75, 1, Z + 0.25, 0];
      map.addSource('pmap-sea', { type: 'geojson', data: { type: 'Feature', properties: {}, geometry: { type: 'Polygon', coordinates: [[[-40, 35], [30, 35], [30, 72], [-40, 72], [-40, 35]]] } } });
      map.addSource('pmap-outline', { type: 'geojson', data: this.ds.outline });
      map.addLayer({ id: 'pmap-poster-sea', type: 'fill', source: 'pmap-sea', maxzoom: Z + 0.5, paint: { 'fill-color': this.ds.posterSea, 'fill-opacity': fade } });
      map.addLayer({ id: 'pmap-poster-land', type: 'fill', source: 'pmap-outline', maxzoom: Z + 0.5, paint: { 'fill-color': this.ds.posterLand, 'fill-opacity': fade } });
      map.addLayer({ id: 'pmap-poster-coast', type: 'line', source: 'pmap-outline', maxzoom: Z + 0.5, paint: { 'line-color': this.ds.posterCoast, 'line-width': ['interpolate', ['linear'], ['zoom'], 4, 0.8, 7, 1.6], 'line-opacity': fade } });
    }

    // Pin images
    var px = 26;
    ORDER.forEach(function (k) {
      map.addImage('pmap-' + k, shapeImage(k === 's' ? 'tri' : 'dot', self.colors[k], px), { pixelRatio: 2 });
      map.addImage('pmap-so-' + k, shapeImage(k === 's' ? 'tri' : 'dot', self.colors.soldout, px), { pixelRatio: 2 });
    });

    map.addSource('pmap-routes', { type: 'geojson', data: { type: 'FeatureCollection', features: [] } });
    map.addSource('pmap-points', { type: 'geojson', data: this.pointData() });
    map.addSource('pmap-me', { type: 'geojson', data: { type: 'FeatureCollection', features: [] } });

    var colorExpr = ['match', ['get', 'c'], 's', this.colors.s, 'nt', this.colors.nt, 'sgt', this.colors.sgt, this.colors.other];
    map.addLayer({ id: 'pmap-routes-hit', type: 'line', source: 'pmap-routes', paint: { 'line-color': '#000', 'line-opacity': 0, 'line-width': 18 } });
    map.addLayer({
      id: 'pmap-routes', type: 'line', source: 'pmap-routes',
      layout: { 'line-cap': 'round', 'line-join': 'round' },
      paint: {
        'line-color': ['case', ['get', 'so'], this.colors.soldout, colorExpr],
        'line-width': ['interpolate', ['linear'], ['zoom'], 5, ['case', ['get', 'sel'], 5, 2.5], 10, ['case', ['get', 'sel'], 7, 4]],
        'line-opacity': ['case', ['get', 'dim'], 0.2, 0.9]
      }
    });
    map.addLayer({
      id: 'pmap-sel', type: 'circle', source: 'pmap-points', filter: ['==', ['get', 'sel'], true],
      paint: { 'circle-radius': 20, 'circle-color': 'rgba(255,255,255,0.55)', 'circle-stroke-color': '#1E2A23', 'circle-stroke-width': 2.5 }
    });
    map.addLayer({
      id: 'pmap-pins', type: 'symbol', source: 'pmap-points',
      layout: {
        'icon-image': ['get', 'icon'],
        'icon-allow-overlap': true,
        'icon-ignore-placement': true,
        'icon-size': ['interpolate', ['linear'], ['zoom'], 4, ['case', ['get', 'sel'], 1.15, 0.8], 8, ['case', ['get', 'sel'], 1.35, 1], 12, ['case', ['get', 'sel'], 1.5, 1.15]],
        'symbol-sort-key': ['case', ['get', 'sel'], 2, ['==', ['get', 'c'], 's'], 1, 0]
      },
      paint: { 'icon-opacity': ['case', ['get', 'dim'], 0.25, 1] }
    });
    map.addLayer({
      id: 'pmap-labels', type: 'symbol', source: 'pmap-points', minzoom: 8.5,
      filter: ['!', ['get', 'dim']],
      layout: {
        'text-field': ['get', 'name'],
        'text-font': ['Noto Sans Regular'],
        'text-size': 12,
        'text-offset': [0, 1.2],
        'text-anchor': 'top',
        'text-optional': true
      },
      paint: { 'text-color': '#1E2A23', 'text-halo-color': 'rgba(255,253,248,0.95)', 'text-halo-width': 1.6 }
    });

    // "You are here" dot for Near me, drawn above the pins so it's never hidden.
    map.addLayer({
      id: 'pmap-me-halo', type: 'circle', source: 'pmap-me',
      paint: { 'circle-radius': 22, 'circle-color': '#2563EB', 'circle-opacity': 0.16, 'circle-stroke-color': '#2563EB', 'circle-stroke-width': 1, 'circle-stroke-opacity': 0.35 }
    });
    map.addLayer({
      id: 'pmap-me', type: 'circle', source: 'pmap-me',
      paint: { 'circle-radius': 8, 'circle-color': '#2563EB', 'circle-stroke-color': '#ffffff', 'circle-stroke-width': 3 }
    });
    map.addLayer({
      id: 'pmap-me-label', type: 'symbol', source: 'pmap-me',
      layout: {
        'text-field': 'You',
        'text-font': ['Noto Sans Regular'],
        'text-size': 13,
        'text-offset': [0, 1.7],
        'text-anchor': 'top',
        'text-allow-overlap': true,
        'text-ignore-placement': true
      },
      paint: { 'text-color': '#1D4ED8', 'text-halo-color': '#ffffff', 'text-halo-width': 2 }
    });

    this.dom.loading.hidden = true;
    this.root.classList.add('pmap--ready');
    this.loadRoutes();
    this.syncMap();
  };

  PatchMap.prototype.pointData = function () {
    var s = this.state, self = this;
    var near = {};
    if (s.near && s.me) this.listed().forEach(function (r) { near[r.it.i] = true; });
    return {
      type: 'FeatureCollection',
      features: this.items.filter(this.visible, this).map(function (it) {
        var dim = (!!s.q && !self.matches(it)) || (s.near && !!s.me && !near[it.i]);
        return {
          type: 'Feature',
          geometry: { type: 'Point', coordinates: [it.lng, it.lat] },
          properties: { i: it.i, c: it.c, name: it.name, icon: (it.avail ? 'pmap-' : 'pmap-so-') + it.c, dim: dim, sel: s.sel === it.i }
        };
      })
    };
  };

  PatchMap.prototype.routeData = function () {
    var s = this.state, self = this;
    var feats = [];
    (this.routes || []).forEach(function (r) {
      var it = self.items[r.i];
      if (!self.visible(it)) return;
      feats.push({
        type: 'Feature', geometry: r.g,
        properties: { i: it.i, c: it.c, so: !it.avail, sel: s.sel === it.i, dim: (!!s.q && !self.matches(it)) }
      });
    });
    return { type: 'FeatureCollection', features: feats };
  };

  PatchMap.prototype.loadRoutes = function () {
    var self = this;
    this.routes = [];
    var todo = this.items.filter(function (it) { return it.route; });
    todo.forEach(function (it) {
      fetch(it.route).then(function (r) { return r.json(); }).then(function (gj) {
        var feats = gj.type === 'FeatureCollection' ? gj.features : (gj.type === 'Feature' ? [gj] : [{ geometry: gj }]);
        feats.forEach(function (f) {
          if (f && f.geometry && /LineString/.test(f.geometry.type)) self.routes.push({ i: it.i, g: f.geometry });
        });
        it.hasLine = true;
        self.syncMap();
        if (self.state.sel === it.i) self.renderCard();
      }).catch(function () { /* start pin only */ });
    });
  };

  PatchMap.prototype.syncMap = function () {
    var map = this.map;
    if (!map || !map.getSource('pmap-points')) return;
    map.getSource('pmap-points').setData(this.pointData());
    map.getSource('pmap-routes').setData(this.routeData());
    // Once someone has used Near me, keep their dot on the map even after the list is closed.
    var me = this.state.me;
    map.getSource('pmap-me').setData({
      type: 'FeatureCollection',
      features: me ? [{ type: 'Feature', properties: {}, geometry: { type: 'Point', coordinates: [me.lng, me.lat] } }] : []
    });
  };

  PatchMap.prototype.hit = function (pt) {
    var map = this.map;
    if (!map || !map.getLayer('pmap-pins')) return null;
    var r = 20;
    var box = [[pt.x - r, pt.y - r], [pt.x + r, pt.y + r]];
    var fs = map.queryRenderedFeatures(box, { layers: ['pmap-pins', 'pmap-routes-hit'] });
    if (!fs.length) return null;
    var best = null, bestD = Infinity, self = this;
    fs.forEach(function (f) {
      var it = self.items[f.properties.i];
      if (!it) return;
      var p = map.project([it.lng, it.lat]);
      var d = Math.hypot(p.x - pt.x, p.y - pt.y) + (f.layer.id === 'pmap-routes-hit' ? 30 : 0) + (f.properties.dim ? 25 : 0);
      if (d < bestD) { bestD = d; best = it; }
    });
    return best;
  };

  PatchMap.prototype.onMapClick = function (e) {
    var it = this.hit(e.point);
    if (it) {
      this.select(it.i, { fly: false });
      if (this.isMobile()) {
        var map = this.map, self = this;
        requestAnimationFrame(function () {
          map.easeTo({ center: [it.lng, it.lat], padding: self.padding(), duration: REDUCED ? 0 : 400 });
        });
      }
    } else if (this.state.sel > -1) this.clearSel(false);
  };

  PatchMap.prototype.flyToItem = function (it) {
    var map = this.map;
    var z = Math.max(map.getZoom(), it.c === 's' ? 10 : 8);
    var opts = { center: [it.lng, it.lat], zoom: z, padding: this.padding() };
    if (REDUCED) map.jumpTo(opts); else map.flyTo(Object.assign({ speed: 1.6, curve: 1.3 }, opts));
  };

  PatchMap.prototype.fitNearest = function () {
    if (!this.map || !this.state.me) return;
    // Centre on the visitor, zoomed out just far enough to show their 3 nearest patches around them.
    var me = this.state.me, dx = 0.02, dy = 0.02;
    this.listed().slice(0, 3).forEach(function (r) {
      dx = Math.max(dx, Math.abs(r.it.lng - me.lng));
      dy = Math.max(dy, Math.abs(r.it.lat - me.lat));
    });
    this.map.fitBounds([[me.lng - dx, me.lat - dy], [me.lng + dx, me.lat + dy]], { padding: this.padding(), maxZoom: 11, duration: REDUCED ? 0 : 900 });
  };

  PatchMap.prototype.home = function () {
    if (!this.map) return;
    this.map.fitBounds(this.bounds(), { padding: 20, duration: REDUCED ? 0 : 800 });
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-pmap]').forEach(function (root) {
      if (root.__pmap) return;
      root.__pmap = new PatchMap(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
